// src/hooks/useAuth.js
import { useState, useEffect } from 'react';
import { signOut } from 'firebase/auth';
import { onValue, ref } from 'firebase/database';
import { auth, database } from '../firebase';

// Custom hook to handle authentication and user profile data
export const useAuth = () => {
  const [user, setUser] = useState(null);
  const [userProfile, setUserProfile] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((currentUser) => {
      setUser(currentUser);

      if (currentUser) {
        // Get user profile data from Realtime Database
        const userRef = ref(database, 'users/' + currentUser.uid);
        const userListener = onValue(userRef, (snapshot) => {
          const profileData = snapshot.val();
          setUserProfile(profileData);
          setLoading(false);
        });

        return () => {
          // Clean up database listener
          userListener();
        };
      } else {
        setUserProfile(null);
        setLoading(false);
      }
    });

    return () => {
      // Clean up auth listener
      unsubscribe();
    };
  }, []);

  // Add logout function
  const logout = async () => {
    try {
      await signOut(auth);
      return true;
    } catch (error) {
      console.error('Error signing out:', error);
      return false;
    }
  };

  // Check if user has admin permissions
  const isAdmin = userProfile?.role === 'admin' || userProfile?.permissions?.admin === true;

  return { user, userProfile, loading, logout, isAdmin };
};

export default useAuth;